import React from 'react';
import { connect } from 'react-redux';
import { func, shape, bool } from 'prop-types';
import { Button, Spinner } from '@noths/shared-components';
import Types from '../../redux/types';
import Panel from '../../components/Panel';
import SubscribeCheckbox from '../../components/SubscribeCheckbox';
import MyAccountMenu from '../../components/MyAccountMenu';
import Tick from '../../components/Tick';
import ErrorPanel from '../../components/ErrorPanel';
import IconPost from '../../images/icon-post.svg';
import IconEmail from '../../images/icon-email.svg';
import InfoPanel from '../../components/InfoPanel';
import { errorPropType } from '../../prop-types';

import {
  Container,
  Blurb,
  FormContainer,
  SpinnerWrapper,
  TickWrapper,
  AppPreferenceContainer,
  AppPreferenceTitle,
  AppPreferenceDescription,
  ButtonContainer,
  PrivacyPolicyLink,
  MarketingPreferencesCheckboxes,
} from './styles';

export class MarketingPreferences extends React.Component {
  static propTypes = {
    getPreferences: func.isRequired,
    updatePreferences: func.isRequired,
    toggleCheckbox: func.isRequired,
    marketingPreferences: shape({
      waitingForResponse: bool.isRequired,
      directMailStatus: bool,
      emailStatus: bool,
      error: errorPropType,
    }).isRequired,
  };

  componentDidMount() {
    this.props.getPreferences();
  }

  handleSubmit = e => {
    e.preventDefault();
    const { directMailStatus, emailStatus, originalStatus } = this.props.marketingPreferences;
    this.props.updatePreferences({ directMailStatus, emailStatus, originalStatus });
  };

  requestSpinner = () =>
    this.props.marketingPreferences.waitingForResponse ? (
      <SpinnerWrapper data-testid="loading">
        <Spinner />
      </SpinnerWrapper>
    ) : (
      this.firstRender()
    );

  firstRender = () =>
    this.props.marketingPreferences.firstRender ? null : (
      <TickWrapper>
        <Tick />
      </TickWrapper>
    );

  render() {
    const {
      error,
      directMail,
      email,
      submitDisabled,
      waitingForResponse,
      showUnsubscribeNotification,
    } = this.props.marketingPreferences;
    return (
      <Container>
        <MyAccountMenu />
        <MarketingPreferencesCheckboxes>
          <Blurb>
            We want you to be delighted every time you receive an email or post from us. The first
            step is setting up your marketing choices. It only takes a few moments. Just select the
            communications you'd like to receive.
          </Blurb>
          {error && <ErrorPanel error={error} />}
          {showUnsubscribeNotification && (
            <InfoPanel
              type="information"
              message="Please note it can take up to 48 hours for our system to process your request, so you might continue to receive emails until this happens."
            />
          )}
          <FormContainer onSubmit={this.handleSubmit} waitingForResponse={waitingForResponse}>
            <SubscribeCheckbox
              icon={IconEmail}
              description={
                <div>
                  See our{' '}
                  <PrivacyPolicyLink href="/about/privacy" target="_blank">
                    privacy policy
                  </PrivacyPolicyLink>{' '}
                  for details about how we process your personal data for sending you email
                  marketing
                </div>
              }
              purpose="Receive marketing email"
              intention="Yes, I would like to"
              name="emailStatus"
              status={email.currentStatus}
              data-marketing-page-email={email.currentStatus}
              explainer={!email.currentStatus}
              handleCheck={() => {
                if (!waitingForResponse) this.props.toggleCheckbox({ checkBox: 'email' });
              }}
              disabled={waitingForResponse}
            />
            <SubscribeCheckbox
              icon={IconPost}
              description={
                <div>
                  See our{' '}
                  <PrivacyPolicyLink href="/about/privacy" target="_blank">
                    privacy policy
                  </PrivacyPolicyLink>{' '}
                  for details about how we process your personal data to send you direct marketing
                  by post
                </div>
              }
              purpose="Receive marketing by post"
              intention="Yes, I would like to"
              name="directMailStatus"
              status={directMail.currentStatus}
              data-marketing-page-directmail={directMail.currentStatus}
              explainer={!directMail.currentStatus}
              handleCheck={() => {
                if (!waitingForResponse) this.props.toggleCheckbox({ checkBox: 'directMail' });
              }}
              disabled={waitingForResponse}
            />

            <ButtonContainer>
              <Button margin="0 0 15px 0" size="medium" fullWidthOnMobile disabled={submitDisabled}>
                Save
              </Button>
            </ButtonContainer>
            {this.requestSpinner()}
          </FormContainer>
          <AppPreferenceContainer>
            <Panel>
              <AppPreferenceTitle>Do you use our app?</AppPreferenceTitle>
              <AppPreferenceDescription>
                Open up the application on your device to update your marketing preference settings
                there
              </AppPreferenceDescription>
            </Panel>
          </AppPreferenceContainer>
        </MarketingPreferencesCheckboxes>
      </Container>
    );
  }
}

const mapStateToProps = ({ marketingPreferences }) => ({
  marketingPreferences,
});

const mapDispatchToProps = dispatch => ({
  updatePreferences: () => {
    dispatch({ type: Types.WAITING_FOR_RESPONSE });
    dispatch({ type: Types.UPDATE_PREFERENCES });
  },
  getPreferences: () => {
    dispatch({ type: Types.GET_PREFERENCES });
  },
  toggleCheckbox: ({ checkBox }) => dispatch({ type: Types.TOGGLE_CHECKBOX, channel: checkBox }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingPreferences);
